function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "my vector image");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var SvgExtruder = function SvgExtruder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 136.80341757727615,
    viewBox: "0 0 112 136.80341757727615",
    className: "extruder-svg",
    style: {},
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#FFFFFF",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _ref3, /*#__PURE__*/React.createElement("path", {
    fill: "#4a90d6",
    fillOpacity: 1,
    stroke: "#222222",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeDasharray: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_1",
    d: "M759.2854322589691,446.46150987012095 ",
    style: {
      color: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dadada",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDashoffset: "",
    fillRule: "nonzero",
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    d: "M4.311950586441412,115.78127275345201 L24.18374198032535,3.8154815583538095 L90.42305018305967,3.8154815583538095 L110.29483446399422,115.78127275345201 L4.311950586441412,115.78127275345201 z",
    style: {
      color: "rgb(0, 0, 0)"
    },
    className: "",
    transform: "rotate(-180 57.30340576171876,59.798370361328125) ",
    fillOpacity: 1,
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2b48c",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDashoffset: "",
    fillRule: "nonzero",
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_7",
    d: "M12.76737117661861,110.06894395450985 L29.33907259463126,21.68653639180701 L84.57808028717068,21.68653639180701 L101.14977577348014,110.06894395450985 L12.76737117661861,110.06894395450985 z",
    style: {
      color: "rgb(0, 0, 0)"
    },
    className: "",
    fillOpacity: 1,
    transform: "rotate(-180 56.95857238769532,65.87773132324219) "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dadada",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDashoffset: "",
    fillRule: "nonzero",
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_11",
    d: "M34.03908185149581,131.48563005090313 L42.853183149953864,116.10102508760133 L72.23352238895451,116.10102508760133 L81.04762053247734,131.48563005090313 L34.03908185149581,131.48563005090313 z",
    style: {
      color: "rgb(210, 180, 140)"
    },
    className: "",
    transform: "rotate(-180 57.54335403442383,123.79332733154297) ",
    fillOpacity: 1
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExtruder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/extruder.75ea287d.svg";
export { ForwardRef as ReactComponent };